import { apiFetch, ApiError } from "../../api/client";

const SUBMIT_TIMEOUT_MS = 12_000;

export type SqlTaskRequestPayload = {
  message: string;
  dataset: string;
  datasetTitle: string;
  taskNumber?: number;
  solvedCount?: number;
  topics?: string[];
};

/** Доска открыта как /board/:id — id берём из адреса, виджет его не знает. */
function boardIdFromLocation(): string {
  const m = window.location.pathname.match(
    /\/board\/([0-9a-f-]{36})|\/guest\/([0-9a-zA-Z_-]{6,64})/i
  );
  return (m?.[1] || m?.[2] || "").slice(0, 120);
}

/**
 * Кнопка «Ещё задания» в виджете SQL: просьба уходит в админку.
 * Ошибку показываем прямо в карточке, ничего не теряя молча.
 */
export async function submitSqlTaskRequest(payload: SqlTaskRequestPayload): Promise<void> {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), SUBMIT_TIMEOUT_MS);
  try {
    const data = await apiFetch<{ ok: boolean }>("/api/v1/inbox/task-request", {
      method: "POST",
      json: {
        message: payload.message,
        board_id: boardIdFromLocation(),
        board_url: window.location.href.slice(0, 800),
        dataset: payload.dataset,
        dataset_title: payload.datasetTitle,
        task_number: payload.taskNumber,
        solved_count: payload.solvedCount,
        topics: payload.topics ?? [],
      },
      signal: controller.signal,
    });
    if (!data.ok) throw new ApiError("Сервер не принял запрос", 502);
  } catch (e) {
    if (e instanceof Error && e.name === "AbortError") {
      throw new ApiError("Сервер долго не отвечает. Попробуйте ещё раз.", 504);
    }
    throw e;
  } finally {
    window.clearTimeout(timeoutId);
  }
}
